export const API_URLS = {
	NOTIFICATION: {
		CREATE: "/notification",
		UPDATE: "/notification",
		GET: "/notification",
		DELETE: "/notification",
		COUNT: "/notification/count"
	}
};
